// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `pnpm build-icons` instead of editing. */ import { ReactComponent as CheckDefault } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/default/general/check.svg?react';
import { ReactComponent as CheckSolid } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/solid/general/check.svg?react';
import { createIcons } from '../../Icon';
export const CheckIcon = /* @__PURE__ */ createIcons('Check', {
    default: CheckDefault,
    solid: CheckSolid
});
CheckIcon.supportedTypes = [
    'default',
    'solid'
];
